import { handleFieldChange } from "../../../../Utils";
import { Component } from 'react';
import { Button } from 'react-bootstrap';

import React from 'react';

import FormOverlay from '../../../../components/FormOverlay';
import FieldGroup from '../../../../components/FieldGroup';
import Icon from '../../../../components/Icon';

class Form extends Component {
    constructor(props = { domain: '', type: '', note: '' }) {
        super(props);

        this.state = {
            subdomain_domain: '',
            domain: '',
            type: '',
            note: '',
            hour: null,
            id: null
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleFieldChange = handleFieldChange.bind(this);
    }

    handleSubmit(event) {
        event.preventDefault();

        this.props.onSubmit(this.state, Boolean(this.state.id));
    }

    componentDidMount() {
        if (this.props.domain) {
            const { id, domain, type, note } = this.props.domain;

            this.setState({ id, domain, type, note });
        }
    }

    render() {
        return (
            <FormOverlay onFormHide={this.props.onFormHide}>
                <form onSubmit={this.handleSubmit} style={{ height: "auto", maxWidth: "600px", overflowY: 'initial' }}>
                    <FieldGroup
                        name="subdomain_domain"
                        label="Subdomain.Domain:"
                        onChange={this.handleFieldChange}
                        value={this.state.subdomain_domain}
                    />

                    <FieldGroup
                        name="domain"
                        label="Domain:"
                        onChange={this.handleFieldChange}
                        value={this.state.domain}
                        required
                    />

                    <FieldGroup
                        name="hour"
                        label="Hour:"
                        type={'number'}
                        onChange={this.handleFieldChange}
                        value={this.state.hour}
                    />

                    <FieldGroup
                        name="type"
                        label="Type:"
                        onChange={this.handleFieldChange}
                        value={this.state.type}
                    />

                    <FieldGroup
                        name="note"
                        label="Note:"
                        onChange={this.handleFieldChange}
                        value={this.state.note}
                    />

                    <Button className="pull-right" bsStyle="success" type="submit"><Icon name="floppy-o"/> Save</Button>
                </form>
            </FormOverlay>
        );
    }
}

export default Form;



// WEBPACK FOOTER //
// ./src/scenes/Domains/components/Form/index.js